import React from 'react';
import { ListContentListPage } from '../components/ListContentListPage';
import { IntegrationCard } from '../components/integration/IntegrationCard';
import type { ArticleRow } from '../../../shared/schemas/article';

function renderIntegrations(articles: ArticleRow[]) {
  return (
    <div className="col-span-full grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-3">
      {articles.map((article) => (
        <IntegrationCard
          key={article.slug}
          title={article.title}
          excerpt={article.excerpt ?? ''}
          slug={article.slug}
          coverImageUrl={article.cover_image_url}
        />
      ))}
    </div>
  );
}

export function IntegrationsListPage() {
  return (
    <ListContentListPage
      title="Integrations"
      listProps={{
        emptyMessage: 'No integration articles yet.',
        fetchUrl: '/api/articles?type=integration',
        renderItems: renderIntegrations,
      }}
    />
  );
}
